import NavigateByWeek from './views'

export default NavigateByWeek


// WEBPACK FOOTER //
// ./src/ui/navigate-by-week/index.jsx